import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const invPhoto = (url) => (url && url.startsWith('/api/') ? `${API_URL}${url}` : url || null);
export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const checkPhoto = (f) => {
  if (!PHOTO_TYPES.includes(f.type)) return 'Use a JPG, PNG or WebP image';
  if (f.size > 5 * 1024 * 1024) return 'Photo must be under 5 MB';
  return null;
};

export const uploadInventoryPhoto = (kind, id, file, headers) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API_URL}/api/admin/inventory/${kind}/${id}/photo`, fd, { headers });
};
